import React, { useState } from 'react';

import { Loader } from 'semantic-ui-react';

import _get from 'lodash/get';
import { useSelector } from 'react-redux';

import { useProviderData } from 'components/modules/business-profile/hooks/use-provider-data';
import useProviderEntityAttributes from 'components/modules/business-profile/hooks/use-provider-entity-attributes';
import { getGoogleLocationProviderSettings } from 'components/modules/business-profile/services/provider-service';
import useProviderServiceSettings from 'components/modules/integrations/hooks/use-provider-service-settings';
import LocationSelect from 'components/pages/ecommerce/common/LocationSelect';
import { selectBusinessLocations } from 'selectors/business';

import { filterGoogleConfiguredLocations } from './BusinessInfoTab.utils';
import PlaceActionsForm from './components/PlaceActionsForm';
import ProfileInformationForm from './components/ProfileInformationForm';

import './BusinessInfoTab.scss';

const propTypes = {};

const defaultProps = {};

export default function BusinessInfoTab() {
  const { providerServiceSettings, loading: loadingProviderServiceSettings } =
    useProviderServiceSettings();

  const { providerData, loading: loadingProviderData, updateProviderData } = useProviderData();

  const locations = useSelector(selectBusinessLocations);
  const [selectedLocationId, setSelectedLocationId] = useState(_get(locations, '0.id', null));

  const locationSettings = getGoogleLocationProviderSettings(providerServiceSettings);
  const locationSetting = locationSettings.find(
    (current) => _get(current, 'serviceData.fishermanLocationId') === selectedLocationId,
  );
  const locationSettingId = _get(locationSetting, 'id', null);
  const locationSettingServiceData = _get(locationSetting, 'serviceData', {});
  const fishermanLocationId = _get(locationSettingServiceData, 'fishermanLocationId');
  const placeActionsPushEnabled = _get(
    locationSettingServiceData,
    'settings.placeActions.push.settings.enabled',
  );
  const placeActionsPushSupported = _get(
    locationSettingServiceData,
    'settings.placeActions.push.supported',
  );
  const isPlaceActionsPushEnabled = placeActionsPushEnabled && placeActionsPushSupported;

  function filterLocations(location) {
    return filterGoogleConfiguredLocations(location, locationSettings);
  }

  // Find provider data for the current location setting
  const currentProviderData = providerData.find(
    (data) => _get(data, 'providerSetting') === locationSettingId,
  );

  const {
    providerEntityAttributes: allProviderEntityAttributes,
    getProviderEntityAttributes,
    updateProviderEntityAttribute,
    loading: loadingProviderEntityAttributes,
  } = useProviderEntityAttributes();

  const providerEntityAttributes = allProviderEntityAttributes.filter(
    (providerEntityAttribute) =>
      _get(providerEntityAttribute, 'location') === fishermanLocationId &&
      _get(providerEntityAttribute, 'serviceSetting') === locationSettingId,
  );

  function onChangeLocation(newLocation) {
    const newLocationId = _get(newLocation, 'id');
    setSelectedLocationId(newLocationId);
  }

  const finalLoading =
    loadingProviderServiceSettings || loadingProviderEntityAttributes || loadingProviderData;

  return (
    <div className="business-info-tab">
      {finalLoading && <Loader active inline />}
      {!finalLoading && (
        <>
          <div className="controls">
            <LocationSelect
              activeLocation={selectedLocationId}
              onChangeLocation={onChangeLocation}
              global={false}
              fluid
              hideIfSingleLocation
              hideAllLocationsOption
              filterLocations={filterLocations}
            />
          </div>

          <ProfileInformationForm
            currentProviderData={currentProviderData}
            updateProviderData={updateProviderData}
          />

          <PlaceActionsForm
            locationSetting={locationSetting}
            isPlaceActionsPushEnabled={isPlaceActionsPushEnabled}
            providerEntityAttributes={providerEntityAttributes}
            getProviderEntityAttributes={getProviderEntityAttributes}
            updateProviderEntityAttribute={updateProviderEntityAttribute}
          />
        </>
      )}
    </div>
  );
}

BusinessInfoTab.propTypes = propTypes;
BusinessInfoTab.defaultProps = defaultProps;
